import { Partner, ShoppingCart } from 'app/api/@generated/backend';

import { HouseType } from 'app/pages/order/model/house-type';
import { ShoppingCartUtils } from 'app/utils/shopping-cart-utils';
import { EcomDataLayerEventType } from 'app/data-layers/model/data-layer-event-types';
import { DataLayerUtils } from 'app/data-layers/utils/data-layer-utils';
import {
    getAllPurchasedItemsForSelectedHousingTypeScenario,
    getAllPurchasedItemsForSingleUnitScenario,
} from 'app/data-layers/utils/data-layer-items-utils';
import { i18n } from 'app/i18n';
import { DeliveryStaticData } from 'app/static-data/delivery-static-data';

import { pushFunnelEventStep } from './push-funnel-event-step';
import { pushShippingInfoEvent } from './push-shipping-info-event';

export const pushPurchaseEvent = (
    shoppingCart: ShoppingCart,
    houseType: HouseType,
    isExtraAdded: boolean,
    numberOfWifiUnits: number,
    isPurchasingSingleUnit: boolean,
    orderNumber: string,
    partner?: Partner,
) => {
    const selectedWifiOption = ShoppingCartUtils.getSelectedWifiOption(shoppingCart, numberOfWifiUnits);
    const items = isPurchasingSingleUnit
        ? getAllPurchasedItemsForSingleUnitScenario(shoppingCart, partner)
        : getAllPurchasedItemsForSelectedHousingTypeScenario(shoppingCart, houseType, isExtraAdded, partner);
    const selectionType = isPurchasingSingleUnit ? i18n.product.name.EXTRA_WIFI_UNIT : i18n.product.name[houseType];
    const isHomeGatewayUpgradeRequired = !!shoppingCart.homeGatewayUpgrade;

    pushShippingInfoEvent(items, selectedWifiOption, isHomeGatewayUpgradeRequired, selectionType, partner);

    pushFunnelEventStep(EcomDataLayerEventType.PURCHASE, partner, items);

    DataLayerUtils.pushEcomEventToDataLayer({
        event: EcomDataLayerEventType.PURCHASE,
        selection_type: selectionType,
        ecommerce: {
            tax: 0,
            shipping: DeliveryStaticData.DELIVERY_PRICE,
            transaction_id: orderNumber,
            value: selectedWifiOption.totalFirstYearPrice,
            currency: selectedWifiOption.recurringCharge.currency,
            items,
        },
    });
};
